import { HTTP } from "../helpers/http-common.js";
import axios from "axios";
import config from "../config";
import authHeader from "../helpers/auth-header";

// Crear instancia de axios para FormData (sin Content-Type para que axios lo establezca automáticamente)
const axiosFormData = axios.create({
  baseURL: config.url_api
});

const companiesService = {
  getCompanies,
  getAllCompanies,
  storeCompany,
  updateCompany,
  getCompanyDetail,
  selectCompany,
  getAllCompaniesNotAssignUser,
  updateCompanyConfig,
  deleteCompany,
  deleteCompanyUser,
  activateDeactivateCompany,
  downloadAllFiles
};

export default companiesService;

function getCompanies(page = 1, search = {}) {
  let params = "";

  if (search.term) {
    params += `&search=${search.term}`;
  }

  if (search.options) {
    params += `&options=${search.options}`;
  }

  if (search.perPage) {
    params += `&perPage=${search.perPage}`;
  }

  return HTTP.get(`companies?page=${page}${params}`, {
    headers: {
      Authorization: authHeader()
    }
  });
}

function getAllCompanies(page = 1, search = {}) {
  let params = "";

  if (search.term) {
    params += `&search=${search.term}`;
  }

  if (search.options) {
    params += `&options=${search.options}`;
  }

  if (search.perPage) {
    params += `&perPage=${search.perPage}`;
  }

  return HTTP.get(`all-companies?page=${page}${params}`, {
    headers: {
      Authorization: authHeader()
    }
  });
}

function getAllCompaniesNotAssignUser(user_id) {
  return HTTP.get(`all-companies-not-assign-user?user_id=${user_id}`, {
    headers: {
      Authorization: authHeader()
    }
  });
}

function getCompanyDetail(id) {
  return HTTP.get(`company/${id}`, {
    headers: {
      Authorization: authHeader()
    }
  });
}

function storeCompany(company = {}) {
  return HTTP({
    method: "post",
    url: "store-company",
    data: company,
    headers: {
      Authorization: authHeader(),
      "Content-Type": "multipart/form-data"
    }
  });
}

function updateCompany(company = {}) {
  return HTTP({
    method: "post",
    url: "update-company",
    data: company,
    headers: {
      Authorization: authHeader()
    }
  });
}

function updateCompanyConfig(company = {}) {
  // Si es FormData, usar instancia limpia de axios sin Content-Type
  // axios detectará el FormData y establecerá multipart/form-data automáticamente
  if (company instanceof FormData) {
    console.log('🔵 [SERVICE] updateCompanyConfig: Enviando FormData');
    console.log('🔵 [SERVICE] FormData tiene id?', company.has('id'));
    console.log('🔵 [SERVICE] Valor de id en FormData:', company.get('id'));
    
    // Log de todos los campos del FormData
    console.log('🔵 [SERVICE] Todos los campos del FormData:');
    for (let pair of company.entries()) {
      console.log(`  ${pair[0]}:`, pair[1]);
    }
    
    return axiosFormData.post("update-company-config", company, {
      headers: {
        Authorization: authHeader()
        // NO incluir Content-Type - axios lo detectará automáticamente con el boundary correcto
      }
    });
  }
  
  // Si no es FormData, usar HTTP wrapper normal
  console.log('🔵 [SERVICE] updateCompanyConfig: NO es FormData, usando HTTP wrapper');
  return HTTP({
    method: "post",
    url: "update-company-config",
    data: company,
    headers: {
      Authorization: authHeader()
    }
  });
}

function selectCompany(company = {}) {
  return HTTP({
    method: "post",
    url: "select-company",
    data: company,
    headers: {
      Authorization: authHeader()
    }
  });
}

function deleteCompany(company_id) {
  return HTTP({
    method: "post",
    url: "delete-company",
    data: { id: company_id },
    headers: {
      Authorization: authHeader()
    }
  });
}

function deleteCompanyUser(company_user) {
  return HTTP({
    method: "post",
    url: "delete-company-user",
    data: company_user,
    headers: {
      Authorization: authHeader()
    }
  });
}

function activateDeactivateCompany(data) {
  return HTTP({
    method: "post",
    url: "activate-deactivate-company",
    data: data,
    headers: {
      Authorization: authHeader()
    }
  });
}

function downloadAllFiles(company_id) {
  return HTTP.get(`download-all-files/${company_id}`, {
    headers: {
      Authorization: authHeader()
    },
    responseType: "blob"
  });
}
